import {
	useEffect, useState,
} from 'react';
import { useUrlParams } from '@aleph/shared-components';
import { useSupergridMutations, useSuperGridValidate } from '@aleph/supergrid';
import SpotifyViewSuperGrid from 'wb-spotify/app/routes/superGrid/view/grid';
import { RedditSuperGridContext } from 'wb-reddit/app/routes/superGrid/utils';
import AdAccountMutator from 'wb-spotify/app/routes/superGrid/mutator/adAccount/adAccountMutator';
import useSpotifyClientMutator from 'wb-spotify/app/routes/superGrid/mutator/adAccount/hooks/useSpotifyAdClientMutator';
import { GridApi } from 'ag-grid-community';
import {
	DEFAULT_SUPERGRID_DATE_RANGE,
	getDateRangeForSupergridFromParams,
	SpotifyLevel,
} from 'wb-spotify/app/routes/superGrid/utils';
import SpotifyMutatorSuperGrid from 'wb-spotify/app/routes/superGrid/mutator/container';
import { useNavigate, useParams } from 'react-router-dom';

const defaultSpotifySuperGridUrlParams = {
	level:   SpotifyLevel.AD_ACCOUNT,
	filters: {},
	date:    DEFAULT_SUPERGRID_DATE_RANGE,
	sort:    [],
};

const SpotifySuperGrid = () => {
	const [gridApi, setGridApi] = useState<GridApi | null | undefined>(null);
	const navigate = useNavigate();

	const { params, setUrlParam, setUrlParams } = useUrlParams({
		defaultParams: defaultSpotifySuperGridUrlParams,
		navigate,
		useParams,
	});
	const { context: { setValidations } } = useSuperGridValidate();

	const { hasMutations, clearMutations } = useSupergridMutations();

	const mutationsPresent = hasMutations();

	const {
		mutatingClient,
		setMutatingClient,
	} = useSpotifyClientMutator();

	useEffect(() => {
		if (!mutationsPresent) {
			setUrlParams({
				...params,
				inCreate:      undefined,
				creationLevel: undefined,
				date:          getDateRangeForSupergridFromParams(params),
			});
			setValidations([]);
		} else {
			setUrlParam('inCreate', true);
		}
	}, [mutationsPresent]);

	useEffect(() => {
		if (!params.inCreate && mutationsPresent) {
			clearMutations();
		}
	}, [params.inCreate]);

	if (!params.date) {
		return null;
	}

	return (
		<RedditSuperGridContext.Provider
			value={{ gridApi, setGridApi }}
		>
			<div
				className="flex flex-1 min-w-0"
			>
				{ mutatingClient
					&& <AdAccountMutator
						onClose={() => setMutatingClient(undefined)}
						title={mutatingClient?.adAccountName ?? ''}
					/>
				}
				{hasMutations() ? <SpotifyMutatorSuperGrid /> : <SpotifyViewSuperGrid />}
			</div>
		</RedditSuperGridContext.Provider>
	);
};

export default SpotifySuperGrid;
